export default {
  search: {
    origin: 'search',
    leftTitle: 'Live Auctions',
    loading: true,
  },
  searchFilters: {
    origin: 'searchFilters',
    comingFrom: 'search',
    middleTitle: 'Search & Filter',
  },
  savedSearches: {
    origin: 'savedSearches',
  },
  searchFilterFlyout: {
    origin: 'searchFilterFlyout',
    clearButton: {
      content: 'Clear',
    },
  },
  srpEventsDirectory: {
    origin: 'srpEventsDirectory',
    middleTitle: 'Events Directory',
    restoreOriginFromNav: 'search',
  },
  marketReport: {
    origin: 'marketReport',
    showBackButton: false,
    middleTitle: 'Market Report',
  },
  marketReportFilters: {
    origin: 'marketReportFilters',
    comingFrom: 'marketReport',
    middleTitle: 'Filters',
  },
  bottomNavigationMenu: {
    origin: 'bottomNavigationMenu',
    navigationMenu: true,
    showBackButton: false,
    middleTitle: 'Menu',
    hideLeftTitleIcon: true,
    hideRight: true,
  },
};
